import Caption from 'components/Luxkit/Typography/Caption'
import React from 'react'
import LePackageUpgradePrice from './LePackageUpgradePrice'
import FormatCurrency from 'components/Common/FormatCurrency'
import PriceRowCaption from 'components/Luxkit/PricePoints/PriceRowCaption'
import getPackageUpgradePrice from './getPackageUpgradePrice'
import { pluralizeToString } from 'lib/string/pluralize'
import { VIRGIN_VELOCITY_BURN_RATE } from 'constants/partnerships'
import { commaSeparatedNumber } from 'lib/format/formatNumber'
import VelocityIcon from 'components/Common/Vendors/Partnership/PartnershipIcons/VelocityIcon'
import { PackageOptionUpgradeView } from './PackageUpgradeModal'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import Group from 'components/utils/Group'

interface Props {
  packageUpgrade: PackageOptionUpgradeView
  hasFlightsSelected?: boolean
}

function LePackageUpgradeWithVelocityPoints({ packageUpgrade, hasFlightsSelected }: Props) {
  const { total, duration, price: upgradePrice } = getPackageUpgradePrice(packageUpgrade, hasFlightsSelected)
  const velocityPoints = Math.floor(upgradePrice / VIRGIN_VELOCITY_BURN_RATE)

  return (<Group
    direction="vertical"
    gap={8}
    tabletDirection="horizontal"
    tabletVerticalAlign="center"
    tabletHorizontalAlign="space-between"
    tabletGap={16}
  >
    <LePackageUpgradePrice
      packageUpgrade={packageUpgrade}
      hasFlightsSelected={hasFlightsSelected}
    />
    <Caption variant="large" colour="neutral-three">OR</Caption>
    <div>
      <BodyTextBlock weight="bold" variant="large" endIcon={<VelocityIcon />}>
        +{commaSeparatedNumber(velocityPoints)} Velocity Points
      </BodyTextBlock>
      <PriceRowCaption>
        <FormatCurrency value={total}/> total for {pluralizeToString('night', duration)}
      </PriceRowCaption>
    </div>
  </Group>)
}

export default LePackageUpgradeWithVelocityPoints
